import API from "..";
import {
  API_POSITION,
  API_POSITION_DELETES,
} from "../../constants/api";

async function getPositions(url) {
  try {
    const response = await API.get(url);
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

async function addPosition(formAddPosition) {
  try {
    const response = await API.post(API_POSITION, formAddPosition);
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

async function updatePosition(id, formUpdatePosition) {
  try {
    const response = await API.put(`${API_POSITION}/${id}`, formUpdatePosition);
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

async function deletePosition(id) {
  try {
    const response = await API.delete(`${API_POSITION}/${id}`);
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

async function deletePositions(ids) {
  try {
    const response = await API.post(
      API_POSITION_DELETES,
      {
        position_ids: ids,
      },
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

export {
  getPositions,
  addPosition,
  updatePosition,
  deletePosition,
  deletePositions,
};
